module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name,
      "isDashboard": !_vm.child,
      "onBack": true
    },
    on: {
      "backClick": _vm.backToDashboard
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('v-pie')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-table')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-bars')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-iot')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('v-center', {
    attrs: {
      "child": _vm.child
    },
    on: {
      "clickChild": _vm.clickChild
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('v-bar')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-flow')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-circle-bar')], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dfccc46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/index.vue
// module id = 1985
// module chunks = 2